import Cookies from "js-cookie";
import { MyCartQty,SaveMyCart } from "@/api/merchant/cart";
const state = {
  confirmObj: JSON.parse(sessionStorage.getItem("confirmObj")),
  cartNum: Cookies.get("cartNum")||0,
};
const mutations = {
  SET_CONFIRM: (state, obj) => {
    state.confirmObj = obj;
    // sessionStorage.setItem("confirmObj", JSON.stringify(obj));
  },
  ADD_PART: (state, num) => {
    state.cartNum += num;
  },
  SET_CART_NUM: (state, num) => {
    state.cartNum = num;
  },
};
const actions = {
  getCartNum({ commit }) {
    return new Promise((resolve) => {
      MyCartQty().then((num) => {
        commit("SET_CART_NUM", num);
        Cookies.set("cartNum",num)
        resolve(num);
      });
    });
  },
  addToCart({ commit,dispatch, state }, param = {}) {
    return new Promise((resolve) => {
      SaveMyCart(param).then((res) => {
        // commit("ADD_PART", 1);
        dispatch("getCartNum")
        resolve();
      });
      // setTimeout(() => {
      //   commit("ADD_PART", num);
      //   resolve();
      // }, 200);
    });
  },
 
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
